import { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Facebook } from "lucide-react";
export default function CallToAction() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section style={{
    backgroundColor: "rgb(30, 41, 59)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(249, 249, 246)",
    fontFamily: "Inter, sans-serif",
    paddingTop: "96px",
    paddingBottom: "96px",
    textAlign: "center"
  }} className="!bg-[rgba(42,98,189,1)]">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Inter:wght@400;500&display=swap');
      `}</style>
      <div className="page-container">
        <div ref={ref} className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 style={{
          color: "rgb(249, 249, 246)",
          fontFamily: '"Playfair Display", serif',
          fontSize: "48px",
          fontWeight: "700",
          lineHeight: "48px",
          border: "0px solid rgb(222, 222, 211)",
          textAlign: "center",
          marginBottom: "24px"
        }} className="!text-xl">Collection and Drop off AVAILABLE</h2><h2 style={{
          color: "rgb(249, 249, 246)",
          fontFamily: '"Playfair Display", serif',
          fontSize: "48px",
          fontWeight: "700",
          lineHeight: "48px",
          border: "0px solid rgb(222, 222, 211)",
          textAlign: "center",
          marginBottom: "24px"
        }} className="!font-thin !font-sans !text-center !text-lg">TM Plant Carlisle – Professional Garden &amp; Construction Equipment Repairs <br />At TM Plant Carlisle, we believe that reliable equipment is the key to safe and efficient work. We specialise in the repair, servicing and maintenance of garden machinery, small construction equipment and gas nail guns. With years of experience, technical expertise and a customer-focused approach, we are committed to delivering a professional service of the highest standard. We work with both private customers and businesses, providing repairs and servicing for lawn mowers, ride-on mowers, chainsaws, brush cutters, hedge trimmers, plate compactors, generators, gas nail guns and many other types of equipment. We specialise in servicing and repairing machines from well-known global manufacturers, allowing us to accurately diagnose faults and restore a wide range of equipment used by homeowners, contractors and professionals. Every repair is carried out with great attention to detail, using proven diagnostic methods and high-quality replacement parts. Why Choose TM Plant Carlisle? Experienced and Professional – We accurately diagnose faults and restore your equipment to full working condition. Extensive Technical Knowledge – We have experience servicing equipment from leading global manufacturers and continuously develop our skills to keep up with the latest technologies. Honest and Transparent Service – Clear quotations, honest advice and solutions tailored to your needs. Fast Turnaround Times – We understand how important reliable equipment is, so we aim to complete repairs as quickly as possible. Quality Workmanship – Every machine is serviced with care and precision to ensure safety, reliability and long-lasting performance. Friendly Customer Service – We believe in building long-term relationships based on trust, professionalism and excellent customer care. Our goal is not only to repair your equipment but also to give you complete confidence that your machinery is in safe and experienced hands. The trust our customers place in us motivates us to maintain the highest standards in everything we do. Whether it's garden machinery, construction equipment or gas nail guns, TM Plant Carlisle is dedicated to providing reliable repairs and expert servicing for equipment from leading global manufacturers. If you are looking for a trustworthy, professional and dependable repair service, we are here to help.</h2><h2 style={{
          color: "rgb(249, 249, 246)",
          fontFamily: '"Playfair Display", serif',
          fontSize: "48px",
          fontWeight: "700",
          lineHeight: "48px",
          border: "0px solid rgb(222, 222, 211)",
          textAlign: "center",
          marginBottom: "24px"
        }} className="!text-xl">
            Keep Your Equipment Running Smoothly
          </h2>
          <p style={{
          color: "rgba(249, 249, 246, 0.8)",
          fontFamily: "Inter, sans-serif",
          fontSize: "20px",
          fontWeight: "400",
          lineHeight: "28px",
          border: "0px solid rgb(222, 222, 211)",
          textAlign: "center",
          maxWidth: "560px",
          marginLeft: "auto",
          marginRight: "auto",
          marginBottom: "40px"
        }} className="!text-base">
            Contact TM Plant Carlisle today to request a service, book a repair, or get advice on your machinery. Fast, professional service at competitive rates.
          </p><p style={{
          color: "rgba(249, 249, 246, 0.8)",
          fontFamily: "Inter, sans-serif",
          fontSize: "20px",
          fontWeight: "400",
          lineHeight: "28px",
          border: "0px solid rgb(222, 222, 211)",
          textAlign: "center",
          maxWidth: "560px",
          marginLeft: "auto",
          marginRight: "auto",
          marginBottom: "40px"
        }} className="!text-xl">**Important Notice** <br /><br />TM Plant Carlisle is an&nbsp;indpendent machinery repair and servicing workshop.We are not a dealer, authorised distributor, or official representative of any manufacturer or brand shown on this website. Any logos, brand names, machines, or images displayed are used for identification and reference purposes only, showing the types of equipment we repair, service, and maintain. We are an independent service provider offering professional repairs, maintenance, and support across a wide range of machinery, regardless of manufacturer.</p>
          <div className="flex flex-col items-center justify-center gap-4">
            <div className="flex flex-wrap items-center justify-center gap-2 text-white/90 text-base">
              <span><Facebook className="lucide lucide-facebook lucide lucide-facebook lucide lucide-facebook lucide lucide-facebook lucide lucide-facebook lucide lucide-facebook mr-2 inline-block size-4 !w-[60px] !h-[60px]" />Follow us on Facebook:</span>
              <Link className="underline hover:text-white font-medium" href="https://www.facebook.com/p/TM-Plant-100087877317818/" newTab>TM Plant Carlisle</Link>
              <span>and</span>
              <Link className="underline hover:text-white font-medium" href="https://www.facebook.com/p/Toby-Plant-100088218721394/" newTab>
                Toby Plant
              </Link>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <Button asChild variant="outline" className="border-border text-foreground hover:bg-accent hover:text-accent-foreground px-8 py-4 rounded-lg shadow-sm">
                
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}